"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Text = _interopRequireDefault(require("../Text/Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ButtonIcon = function ButtonIcon(_ref) {
  var variant = _ref.variant,
      icon = _ref.icon,
      disabled = _ref.disabled,
      size = _ref.size,
      ariaLabel = _ref.ariaLabel,
      count = _ref.count,
      props = _objectWithoutPropertiesLoose(_ref, ["variant", "icon", "disabled", "size", "ariaLabel", "count"]);

  return (0, _themeUi.jsx)("button", _extends({}, props, {
    disabled: disabled,
    "aria-label": ariaLabel,
    sx: {
      display: 'inline-block',
      width: size,
      height: size,
      borderRadius: '50%',
      outline: 'none',
      variant: "buttons.ButtonIcon." + variant,
      flexShrink: 0,
      position: 'relative',
      cursor: disabled ? 'default' : 'pointer',
      pointerEvents: disabled ? 'none' : 'auto'
    }
  }), (0, _themeUi.jsx)(_Icon["default"], {
    icon: icon,
    size: size - 2,
    sx: {
      color: 'inherit'
    }
  }), count >= 0 && (0, _themeUi.jsx)(_themeUi.Flex, {
    sx: {
      position: 'absolute',
      top: 0,
      right: 0,
      bg: 'alerts.error',
      height: 1,
      width: 1,
      borderRadius: '50%',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white'
    }
  }, (0, _themeUi.jsx)(_Text["default"], {
    variant: "display"
  }, count < 100 ? count : 99)));
};

ButtonIcon.propTypes = {
  variant: _propTypes["default"].oneOf(['light', 'dark']),
  icon: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool,
  size: _propTypes["default"].number,
  ariaLabel: _propTypes["default"].string.isRequired,
  count: _propTypes["default"].number
};
ButtonIcon.defaultProps = {
  variant: 'dark',
  disabled: false,
  size: 4
};
var _default = ButtonIcon;
exports["default"] = _default;